'use client';

import { NeuroMessageScope, NeuroMessageType } from '@/enums';
import { IProductSize, NeuroMarketingMessage } from '@/interfaces/product';
import Image from 'next/image';

const NeuroMarketingProductDetails = (props: {
  neuroMarketingMessages: NeuroMarketingMessage[];
  productSize?: number;
  variantStockInfo?: IProductSize[];
}) => {
  const { neuroMarketingMessages, productSize, variantStockInfo } = props;

  if (neuroMarketingMessages?.length === 0 || !neuroMarketingMessages) return null;

  const processMessage = (message: NeuroMarketingMessage) => {
    let processedMessageText = message?.Message;

    if (productSize && productSize > -1 && message?.MessageType === NeuroMessageType.Sales && message?.VariantWiseTotalSold) {
      const sizeKey = `Size:${productSize}`;

      if (message?.VariantWiseTotalSold?.hasOwnProperty(sizeKey)) {
        const sold = message?.VariantWiseTotalSold[sizeKey];
        const variant = productSize;

        processedMessageText = message?.Message?.replace('{sold}', sold.toString()).replace('{variant}', variant.toString());
      } else {
        processedMessageText = '';
      }
    }

    if (productSize && productSize > -1 && message?.MessageType === NeuroMessageType.Stock && variantStockInfo && variantStockInfo?.length > 0) {
      const matchedVariant = variantStockInfo?.find((variant) => variant?.ProductAttributeValue === productSize);

      if (matchedVariant) {
        const stock = matchedVariant?.StockQuantity;
        const variant = productSize;

        processedMessageText = message?.Message?.replace('{stock}', stock.toString()).replace('{variant}', variant.toString());
      }
    }

    if (!processedMessageText) {
      return null;
    }

    return (
      <div className="mt-5 flex flex-col gap-2">
        <div key={message.Id} className="flex items-center gap-1.5">
          {message?.Icon && <Image src={message.Icon} alt={message.RuleName} width={24} height={24} />}
          <strong className="text-lg font-semibold">{processedMessageText}</strong>
        </div>
      </div>
    );
  };

  if (neuroMarketingMessages[0]?.Scope === NeuroMessageScope.VariantLevel) {
    if (productSize !== -1 && productSize !== undefined) {
      return processMessage(neuroMarketingMessages[0]);
    }
    return null;
  }

  return (
    <div className="mt-5 flex flex-col gap-2">
      <div key={neuroMarketingMessages?.[0]?.Id} className="flex items-center gap-1.5">
        {neuroMarketingMessages?.[0]?.Icon && (
          <Image src={neuroMarketingMessages[0].Icon} alt={neuroMarketingMessages?.[0]?.RuleName} width={24} height={24} />
        )}
        <strong className="text-lg font-semibold">{neuroMarketingMessages?.[0]?.Message}</strong>
      </div>
    </div>
  );
};

export default NeuroMarketingProductDetails;
